import { Features } from 'generated/featureDefinitions'
import { MyProjectsSchedulePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import MySchedule from './MySchedule'

const SchedulePage = () => {
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data, loading, error } = useQuery(MyProjectsSchedulePageDocument, {
    variables: {
      companyId: companyId,
      featureIds: [Features.projects_overview],
    },
  })

  const hasScheduleView = !!data?.companies.featureAvailabilitiesConnection.nodes.find(
    (feature) => feature.id === Features.projects_overview
  )?.available

  return (
    <ResponsivePage.Body
      variant="fullscreen"
      showHeader={false}
      loading={loading}
      error={error}
      authorized={hasScheduleView}
    >
      <MySchedule />
    </ResponsivePage.Body>
  )
}

export default SchedulePage
